import api from './api';

const billingService = {
  status: async () => (await api.get('/billing/status')).data,
  checkout: async () => (await api.post('/billing/checkout')).data,
  portal: async () => (await api.post('/billing/portal')).data,
};

export default billingService;
